export default "__VITE_ASSET__ZEenLMoa__"